import { CameraSopNodeType, NetworkNodeType, NodeContext } from "../../engine/poly/NodeContext";
import { CoreObject } from "../geometry/Object";
import { CoreType } from "../Type";
import { CameraAttribute } from "./CoreCamera";
export class CoreCameraPostProcessController {
  static isPostProcessNetworkNode(node) {
    return node.type() == NetworkNodeType.POST || node.context() == NodeContext.SOP && node.type() == CameraSopNodeType.POST_PROCESS;
  }
  static createComposer(options) {
    const { renderer, scene, renderScene, camera } = options;
    let postProcessNode;
    const postProcessNodePath = CoreObject.attribValue(camera, CameraAttribute.POST_PROCESS_PATH);
    if (postProcessNodePath && CoreType.isString(postProcessNodePath)) {
      const foundNode = scene.node(postProcessNodePath);
      if (foundNode && this.isPostProcessNetworkNode(foundNode)) {
        postProcessNode = foundNode;
      }
    }
    if (!postProcessNode) {
      return;
    }
    return postProcessNode.effectsComposerController.createEffectsComposer({
      renderer,
      scene: renderScene,
      camera
    });
  }
}
